import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST_HOVER,
  NOTICE,
  TEXT_SECONDARY
} from "@streeteasy/design-system/colors";
import { LARGE_SCREEN } from "@streeteasy/design-system/constants/screenSizes";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";
import { Caption } from "@streeteasy/design-system/typography";

export const Wrapper = styled.div`
  background: ${ACCENT_PRIMARY_LIGHTEST_HOVER};
  color: ${TEXT_SECONDARY};
  padding-top: 24px;
`;

export const FooterSection = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
  max-width: 980px;
  padding: 0 32px 16px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 24px;
  }
`;

export const FooterItem = styled(Caption).attrs({ as: "li" })`
  padding: 8px 0;
  @media screen and (min-width: ${LARGE_SCREEN + 1}px) {
    padding: 0;
    &:not(:first-child)::before {
      content: "\\00B7"; // &middot;
      padding: 0 8px;
    }
  }
`;

export const FooterLink = styled(TextAction).attrs({
  typography: textActionTypography.CAPTION,
  underlined: false
})``;

export const RedFooterLink = styled(FooterLink)`
  color: ${NOTICE};
`;
